import {
  BATTLE_MODAL_PANEL_SURFACE_FILTER,
  BATTLE_STRATEGY_MODAL_Z_INDEX,
  WELCOME_PANEL_BACKGROUND_PATH,
} from '../config/welcomeAssets';
import {
  MOBILE_BATTLE_MODAL_PANEL_MAX_HEIGHT_PX,
  MOBILE_BATTLE_MODAL_PANEL_WIDTH_PX,
} from '../components/mobile/mobileBattleLayoutOffsets';
import { resolvePublicAssetBackgroundUrl } from './resolvePublicAssetUrl';

export function getStrategyModalPanelStyle(isMobile) {
  return {
    '--strategy-modal-overlay-z-index': BATTLE_STRATEGY_MODAL_Z_INDEX,
    '--strategy-modal-panel-background-image': resolvePublicAssetBackgroundUrl(WELCOME_PANEL_BACKGROUND_PATH),
    '--strategy-modal-panel-surface-filter': BATTLE_MODAL_PANEL_SURFACE_FILTER,
    ...(isMobile
      ? {
          '--mobile-battle-modal-width': `${MOBILE_BATTLE_MODAL_PANEL_WIDTH_PX}px`,
          '--mobile-battle-modal-max-height': `${MOBILE_BATTLE_MODAL_PANEL_MAX_HEIGHT_PX}px`,
        }
      : {}),
  };
}
